// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "tspan{white-space:pre}.shp0{fill:#ffd26e;stroke:#ffd26e}.txt1{font-size:12px;fill:#000;font-family:Myriad Pro}", ""]);
// Exports
module.exports = exports;
